import styled from "styled-components";

export const ButtonClose = styled.button`
  font-size: 1rem;
  border: 0px;
  background: transparent;
`;

export const Icon = styled.i`
  margin-right: 10px;
`;
